/** @file Validation Message for a form field. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { nameValidationMessage } from '../constants';
import { injectFieldContext, useFieldContextValue } from '../context';
import { Message } from './Message';
/** Renders a validation message component for a form field. */
export const ValidationMessage = tsx.componentFactory.create({
    name: nameValidationMessage,
    inject: injectFieldContext(),
    /** @returns The local state of the component. */
    data() {
        return {
            id: undefined,
        };
    },
    props: {
        message: p.ofType().required,
    },
    computed: {
        ...useFieldContextValue(),
    },
    /** Register with the parent Field upon creation. */
    created() {
        this.id = this.fieldContext.register('validation');
    },
    /** Deregister with the parent Field before destroy. */
    beforeDestroy() {
        if (this.id != null) {
            this.fieldContext.deregister(this.id);
        }
    },
    /** @returns Body of the component. */
    render() {
        return (<Message data-cy={nameValidationMessage} semantic="highlighted">
                {this.message}
            </Message>);
    },
});
